import CustomButton from "./CustomButton";
import { SvgGoogle, SvgLinkedin, SvgMeta } from "../Icons/ProviderIcons";

interface ProviderProps {
	onClick?: () => void;
	isFute: boolean;
}

function controlText(isFtue: boolean) {
	return isFtue ? "Sign up with" : "Continue with";
}

export const ProviderGoogle: React.FC<ProviderProps> = ({
	onClick,
	isFute = false
}) => {
	return (
		<CustomButton
			leftIcon={SvgGoogle()}
			text={`${controlText(isFute)} Google`}
			rightIcon="External"
			onClick={onClick}
		/>
	);
};

export const ProviderLinkedin: React.FC<ProviderProps> = ({
	onClick,
	isFute = false
}) => {
	return (
		<CustomButton
			leftIcon={SvgLinkedin()}
			text={`${controlText(isFute)} Linkedin`}
			rightIcon="External"
			onClick={onClick}
		/>
	);
};

export const ProviderMeta: React.FC<ProviderProps> = ({
	onClick,
	isFute = false
}) => {
	return (
		<CustomButton
			leftIcon={SvgMeta()}
			text={`${controlText(isFute)} Meta`}
			rightIcon="External"
			onClick={onClick}
		/>
	);
};
